import { lazy } from 'react'

/**
 * Módulo: Productos (Bombai Fase 3)
 * Catálogo comercial del seller — maestro de qué vende, sourcing, links a
 * publicaciones en plataformas. Base para rentabilidad, reposición, compras.
 */
export default {
  id: 'productos',
  nombre: 'Productos',
  descripcion: 'Catálogo maestro de productos del seller + sourcing y links a plataformas',
  icono: 'package',
  tipo: 'comercial',
  version: '0.1.0',
  // Visible para consultor MilBrands y para cliente/colaborador de la empresa

  routes: [
    // Dentro de una empresa (contexto empresaId en props)
    { path: 'productos', component: lazy(() => import('./pages/ProductosPage')) },
  ],

  // Ítems de menú en el sidebar de la empresa
  // #87 — `permisoModulo` filtra item-by-item según el rol.
  menuItems: [
    { label: 'Productos', path: '/productos', icon: 'package', permisoModulo: 'productos' },
  ],

  features: [
    'productos-abm',
    'productos-sourcing',
    'productos-catalogo-links',
    'productos-maestro-lookup',
  ],

  // permisoModulos (#58): se deriva del rol.
  permisoModulos: ['productos'],

}
